(function ($) {
  $(document).ready(() => {


    $('.push-carousel-fade').each(function () {
      let slider_push = tns({
        "container": this,
        "fixedWidth": 290,
        "gutter": 18,
        "speed": 400,
        "navPosition": "bottom",
        "mouseDrag": true,
        "loop": false,
        "controlsText": ["précédent", "suivant"],
        "responsive": {
          "1200": {
            "fixedWidth": 380,
            "edgePadding": false,
            "gutter": 32,
          }
        }
      })

      $(this).closest('.block-pushs').find('.prev').on('click', function () {
        slider_push.goTo('prev');
      });

      $(this).closest('.block-pushs').find('.next').on('click', function () {
        slider_push.goTo('next');
      });

    });

    $('.push-carousel').each(function () {
      tns({
        "container": this,
        "fixedWidth": 290,
        "gutter": 18,
        "speed": 400,
        "navPosition": "bottom",
        "mouseDrag": true,
        "loop": false,
        "controlsText": ["précédent", "suivant"],
        "responsive": {
          "1200": {
            "fixedWidth": false,
            "edgePadding": 50,
            "edgePadding": false,
            "gutter": 32,
            "items": 3
          }
        }
      })

      $(this).closest('.block-pushs').find('.prev').on('click', function () {
        slider_push.goTo('prev');
      });

      $(this).closest('.block-pushs').find('.next').on('click', function () {
        slider_push.goTo('next');
      });
    });

    
  })
})(jQuery);
